export default  {
    backend_url : 'https://ies.mplaza.training/',
    dashboard_url : 'https://unbored.training/',
    debug_mode : false,

    invigilate: {
      api_url: 'https://invigilation.certn.global/v1/',
      webcam_snapshot_interval: 5000, // milliseconds
      screen_snapshot_interval: 5000, // milliseconds
      user_picture_expires_in: 10, // minutes
      audio_record_duration: 30000, // milliseconds
      audio_record_interval: 20000, // milliseconds
    }


}
